<div id="footer-wr" class="flex flex-col items-center text-sm gap-0.5 pt-2 pb-3">
  <span class="flex items-baseline gap-2">{{ 'CORE_FOOTER.POWERED_BY' | translate }} <img src="../../../../../assets/logos/aricoma-dark.svg" [attr.alt]="'CORE_FOOTER.LOGO_ALT' | translate" class="logo"></span>
</div>
